import React from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { FilterOption } from '../Filter';
import * as filterActions from '../../../filterActions';
import styles from './RadioButtons.module.scss';
import classnames from 'classnames';

interface RadioFilterProps {
    label: string;
    options: FilterOption[];
    dynamicFilterIndex: number;
    currentValue: string;
}

type Props = ReturnType<typeof mapDispatchToProps> & RadioFilterProps;

const mapDispatchToProps = (dispatch: Dispatch) =>
    bindActionCreators(
        {
            updateDynamicFilter: filterActions.updateDynamicFilter,
        },
        dispatch,
    );

const RadioFilter = ({
    label,
    options,
    updateDynamicFilter,
    dynamicFilterIndex,
    currentValue,
}: Props) => {
    const onSelect = (radioId: string, radioValue: string) => {
        updateDynamicFilter(dynamicFilterIndex, radioValue);
    };

    return (
        <div className={styles.radioButtonsContainer}>
            {options.map((item, index) => {
                const isActive = currentValue === item.value;

                return (
                    <div
                        key={`radio${index}-${item.id}`}
                        id={classnames(
                            { 'radiobuttons-radio-button': !isActive },
                            { 'radiobuttons-radio-button-active': isActive },
                        )}
                        className={classnames(styles.radioButton, {
                            [styles.radioButtonActive]: isActive,
                        })}
                    >
                        <input
                            id={item.id}
                            type="radio"
                            name={label}
                            value={item.value}
                            checked={isActive}
                            onChange={() => onSelect(item.id, item.value)}
                        />
                        <label htmlFor={item.id}>{item.value}</label>
                    </div>
                );
            })}
        </div>
    );
};

export default connect(null, mapDispatchToProps)(RadioFilter);
